export default "__VITE_ASSET__339481f6__"